module.exports = __webpack_public_path__ + "img/dp-gr-jf2.5500b48c.png";